export const RECONCILING_PLACEHOLDER_TEXT = "Reconciling…"

export function keepTurnsThroughLastUserTurn<TTurn>(
  turns: TTurn[],
  readTurnRole: (turn: TTurn) => string | undefined,
): TTurn[] {
  const lastUserTurnIndex = turns.map(readTurnRole).lastIndexOf("user")
  return lastUserTurnIndex === -1 ? turns : turns.slice(0, lastUserTurnIndex + 1)
}
